import React from 'react';
import styles from './FieldLabel.module.scss'

function FieldLabel(props) {
    const {field, onRemoveSubCondition} = props;
    return (
        <div className={styles.FieldLabel}>
            <button className={styles.removeSubCondition} type="button" onClick={onRemoveSubCondition}>
                <span className="glyphicon glyphicon-remove-sign pull-left"></span>
            </button>
            <div className="field">{field.label}</div>
        </div>
    );
}

export default FieldLabel;
